/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';

// initial store state
const axiosPayLoad = {
  checkbox: [],
  dropdown: [],
  quarter: '',
  saveUpdateState: true,
  manufacturerList: [],
  checkDetails: [],
  errorMessagesInRedux: {},
  successMessageInRedux: [],
  auditTypeList: [],
  searchCmsRosiObj: {},
  cmsRosiDetailObj: {},
  searchScreenObj: {},
  perviousInvoiceCriteriaRedux: [],
  searchInvoiceByCriteriaList: [],
  ndcLevelDetailList: [],
  ndcAuditDescriptionList: [],
  saveOrUpdateMessage: '',
  auditClearedIndexData: {},
  searchCmsRosiByCriteriaList: {},
  selectedRowData: {},
  
};

// Reducer to update the store data
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_PLAN_TYPE_DATA:
      // eslint-disable-next-line vars-on-top, no-var
      var updatedArray = [];
      if (action.checkbox) {
        // eslint-disable-next-line vars-on-top, no-var
        var localAr = action.checkbox;
        if (localAr?.PLAN_TYPE_CD?.length > 0) {
          const planArray = localAr?.PLAN_TYPE_CD;
          planArray.forEach((element) => {
            if (element?.codeValueID?.codeValue === 'FD') {
              const indexOf = _.findIndex(planArray, element);
              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
              }
              localAr.PLAN_TYPE_CD = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        // eslint-disable-next-line block-scoped-var
        checkbox: localAr,
      };
    case actionTypes.GET_COMMON_DROPDOWN_DATA:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionTypes.GET_QUARTER_DATA:
      return {
        ...state,
        quarter: action.quarter,
      };
    case actionTypes.SEARCH_CMS_ROSI_TAB_DATA:
      return {
        ...state,
        searchCmsRosiObj: action.searchCmsRosiObj,
      };
    case actionTypes.CMS_ROSI_DETAIL_TAB_DATA:
      return {
        ...state,
        cmsRosiDetailObj: action.cmsRosiDetailObj,
      };
    case actionTypes.GET_MANUFACTURER_DATA:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };
    case actionTypes.GET_AUDIT_TYPE_CMS_CD:
      return {
        ...state,
        auditTypeList: action.auditTypeList,
      };
    case actionTypes.CMS_UPDATE_STATE:
      return {
        ...state,
        saveUpdateState: action.saveUpdateState,
      };
    case actionTypes.GET_CMS_ROSI_BY_CRITERIA:
      return {
        ...state,
        searchInvoiceByCriteriaList: action.searchInvoiceByCriteriaList,
      };
    case actionTypes.UPDATE_AUDIT_CLEARED_INDEX_DATA:
      return {
        ...state,
        auditClearedIndexData: action.auditClearedIndexData,
      };
    case actionTypes.GET_SEARCH_CMS_ROSI_BY_CRITERIA_LIST:
      return {
        ...state,
        searchCmsRosiByCriteriaList: action.searchCmsRosiByCriteriaList,
    };
    case actionTypes.GET_SELECTED_ROW_DATA:
      return {
        ...state,
        selectedRowData: action.selectedRowData,
    };
    case actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CMS_ROSI:
      return { ...state, successMessageInRedux: action.successMessageInRedux };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_CMS_ROSI:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    default:
      return state;
  }
};

export default reducer;
